import { ChildIcon } from "./MenuIcons/MenuIcons";

export const StationsList = [
    {
        code: 'AX001',
        name: 'Świdnica',
        devname: 'swidnica'
    },
    {
        code: 'AX002',
        name: 'Lubin',
        devname: 'lubin'
    },
    {
        code: 'AX003',
        name: 'Legnica',
        devname: 'legnica'
    },
];


export const MenuData = [
    {
        title: 'Sprzedaż',
        to: '/sales',
        access: ['admin', 'supply'],
        children: [
            {
                title: 'Świdnica',
                to: '/station?station=AX001',
                icon: <ChildIcon/>,
                access: ['admin', 'sales', 'swidnica', 'supply'],
            },
            {
                title: 'Lubin',
                to: '/station?station=AX002',
                icon: <ChildIcon/>,
                access: ['admin', 'sales', 'lubin', 'supply'],
            },
            {
                title: 'Legnica',
                to: '/station?station=AX003',
                icon: <ChildIcon/>,
                access: ['admin', 'sales', 'legnica', 'supply'],
            },
        ]
    },
    {
        title: 'Raporty',
        to: '/raports',
        access: ['admin', 'supply'],
        icon: '<span>q</span>',
        children: []
    },
    {
        title: 'Zaopatrzenie',
        to: '/supplies',
        access: ['admin', 'supply'],
        icon: '<span>q</span>',
        children: [
            {
                title: 'Stany magazynowe',
                to: '/supplies',
                icon: <ChildIcon/>,
                access: ['admin', 'supply'],
            },
            {
                title: 'Temperatury zbiorników',
                to: '/tanks-temperatures',
                icon: <ChildIcon/>,
                access: ['admin', 'supply'],
            },
        ]
    },
    // {
    //     title: 'Administracja',
    //     to: '/administration',
    //     access: ['admin'],
    //     icon: '<span>q</span>',
    //     children: []
    // },
    {
        title: 'Performance',
        to: '/performance',
        access: ['admin', 'supply'],
        icon: '<span>q</span>',
        children: []
    },
    {
        title: 'Ustawienia',
        to: '/settings',
        access: ['admin', 'supply'],
        icon: '<span>q</span>',
        children: []
    },
];